import React from 'react'
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import WebIcon from '@material-ui/icons/Web';
import { Fade } from "react-reveal";
import "./timeline.css"
import PersonIcon from '@material-ui/icons/Person';

export default function TimeLine(props) {
    const theme = props.theme;
    return (  
        <div>
            <br /> <br />
            <div className="skills-header-div">
                <Fade bottom duration={2000} distance="20px">
                <h1 className="skills-header" style={{ color: theme.text }}>
                    Work Experience
                </h1>
                </Fade>
            </div>
            <VerticalTimeline>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
                    date="2019 - present"
                    dateClassName="dateColor"
                    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    icon={<WebIcon />}
                >
                    <h3 className="vertical-timeline-element-title">IEEE IIITS</h3>
                    <h4 className="vertical-timeline-element-subtitle">Web Designer</h4>
                    <p>
                    Creative Direction, User Experience, Visual Design
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
                    date="2021"
                    dateClassName="dateColor"
                    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    icon={<WebIcon />}
                >
                    <h3 className="vertical-timeline-element-title">GirlScript SoC</h3>
                    <h4 className="vertical-timeline-element-subtitle">Feminist Bible Phase-2 Mentor</h4>
                    <p>
                    ReactJs Project ,Git Management , Guiding/Helping Others 
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
                    date="2021"
                    dateClassName="dateColor"
                    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    icon={<WebIcon />}
                >
                    <h3 className="vertical-timeline-element-title">Skills Spring IIIT Nagpur</h3>
                    <h4 className="vertical-timeline-element-subtitle">Web Development Mentor</h4>
                    <p>
                    Web Development, Guiding/Helping Others 
                    </p>
                </VerticalTimelineElement>
            </VerticalTimeline>

            <div className="skills-header-div">
                <Fade bottom duration={2000} distance="20px">
                <h1 className="skills-header" style={{ color: theme.text }}>
                    Internships
                </h1>
                </Fade>
            </div>
            <VerticalTimeline>
                <VerticalTimelineElement
                    iconStyle={{display:'none'}}
                >
                    
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ background: 'rgb(255, 128, 0)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgb(255, 128, 0)' }}
                    date="2021 - 3 Months"
                    dateClassName="dateColor"
                    iconStyle={{ background: 'rgb(255, 128, 0)', color: '#fff' }}
                    icon={<PersonIcon fontSize="large" />}
                >
                    <h3 className="vertical-timeline-element-title">Mobby Park</h3>
                    <h4 className="vertical-timeline-element-subtitle">Frontend Developer</h4>
                    <p>
                    Backend Integration , UI Integration , Responsive Website 
                    </p>
                </VerticalTimelineElement>
            </VerticalTimeline>
        </div>
    )
}
